import { SubscriptionState, useSubscriptionStore } from "../store/subscription-store"

// Selector hooks for more optimized re-renders
export const useCurrentSubscription = () =>
  useSubscriptionStore((state: SubscriptionState) => state.currentSubscription)
export const usePlans = () => useSubscriptionStore((state: SubscriptionState) => state.plans)
export const useSubscriptionIsLoading = () =>
  useSubscriptionStore((state: SubscriptionState) => state.isLoading)
export const useSubscriptionError = () =>
  useSubscriptionStore((state: SubscriptionState) => state.error)
export const useSubscriptionActions = () =>
  useSubscriptionStore((state: SubscriptionState) => state.actions)

/**
 * Custom hook to manage and access subscription billing information.
 * It initializes data fetching on mount if not already loaded.
 */
export const useSubscription = () => {
  const subscription = useCurrentSubscription()
  const plans = usePlans()
  const isLoading = useSubscriptionIsLoading()
  const error = useSubscriptionError()
  const { fetchBillingInfo } = useSubscriptionActions()

  return {
    currentSubscription: subscription,
    plans,
    isLoading,
    error,
    actions: {
      fetchBillingInfo,
    },
  }
}
